import { Col, Modal, Row, Checkbox } from "antd";
import * as React from "react";
import { confirmable } from "react-confirm";
import "./ChooseUserModal.css";
import Logo from "assets/images/logo-large.png";
import ButtonWithIcon from "components/ButtonWidgets/ButtonWithIcon/ButtonWithIcon";
import CommonButton from "components/ButtonWidgets/CommonButton/CommonButton";
import { useEffect } from "react";
import { useState } from "react";
import NormalButton from "components/ButtonWidgets/NormalButton/NormalButton";
function ChooseUserModal(props) {
  const { show, proceed } = props;
  const { title, userList } = props;
  const [dataList, setDataList] = useState([]);
  useEffect(() => {
    if (userList) {
      setDataList(userList)
    }
  }, [])
  return (
    <Modal
      visible={show}
      destroyOnClose={true}
      onCancel={() => {
        proceed(null);
      }}
      className="participant-choose-modal"
      closable={true}
      maskClosable={false}
      title={title}
      footer={null}
    >
      <div className="rec-alert-title">
        <img src={Logo} alt="Beclutch" className="img-logo" />
      </div>
      <div className="rec-user-content">
        <div style={{ marginTop: 20, fontSize: 18, color: '#7fb522' }}>Please select participant</div>
        {dataList.map((x, index) => {
          return <div key={index}>
            <Checkbox
              onChange={(e) => {
                let tmpList = [...dataList]
                tmpList[index].checked = e.target.checked;
                setDataList(tmpList)
              }}
              checked={x.checked}
            >
              <div style={{ marginTop: 10, fontSize: 15 }}>
                {x?.camper_first_name} {x?.camper_last_name}
              </div>
            </Checkbox>
          </div>
        })}
      </div>
      <div style={{ marginTop: 25, paddingLeft: 50, paddingRight: 50 }}>
        <NormalButton
          style={{ backgroundColor: "#7fb522" }}
          onClick={() => {
            proceed(dataList)
          }}
        >
          Register
        </NormalButton>
      </div>
    </Modal>
  );
}

export default confirmable(ChooseUserModal);
